import React from 'react';
import { motion } from 'framer-motion';
import { trackEvent } from '../utils/metaPixel';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function Button({
  children,
  onClick,
  className = '',
  href
}: ButtonProps) {
  const baseClasses = 'inline-block bg-amber text-white font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:bg-amberHover transition-colors text-center cursor-pointer';
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (!href) {
      trackEvent('AddToCart', {
        content_name: 'Gato de Depto Feliz - Guía',
        content_type: 'product',
        value: 8999,
        currency: 'ARS'
      });
      window.open('https://amigospeludosarg.shop/cart/49017933922546:1', '_blank');
    }
  };
  const content = <motion.div whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`${baseClasses} ${className}`} onClick={handleClick} data-id="element-13">
      {children}
    </motion.div>;
  if (href) {
    return <a href={href} className="inline-block w-full sm:w-auto" data-id="element-14">
        {content}
      </a>;
  }
  return content;
}